var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"table table-striped  table-hover ",staticStyle:{"width":"100%"},attrs:{"id":_vm.id}},[_c('thead',[_c('tr',[_vm._t("default")],2)]),(_vm.config.footer)?_c('tfoot',[_c('tr',[_vm._t("footer")],2)]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }